export const getNoRowsLabel = (search?: string): string =>
  search?.trim() ? 'אין תוצאות לתצוגה' : 'אין נתונים'
